import Search from '../components/Search';
import HotDeals from '../components/HotDeals';
import InstrumentCont from '../components/InstrumentCont';

function mainPage() {
  return (
    <>
      <Search />
      <HotDeals />
      <InstrumentCont />
    </>
  );
}

export default mainPage;
